import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpClient, HttpResponse } from '@angular/common/http';
import { DocumentDownload } from './document.types';
import { SnackbarService } from '../snackbar/snackbar.service';
import {
  WillHandleErrorMessagingHeader,
  WillHandleErrorMessagingOption,
} from '../utility/http-options';

@Injectable({
  providedIn: 'root',
})
export class PrintDocumentService {
  private printJSPart1 = `window.onload = function(){
    // create an element
    var tmp = document.createElement('img');
    // add the doc to it
    tmp.setAttribute('src', '`;

  private printJSPart2 = `');

      // then when that is done loading
      tmp.onload = function(){window.print();};

      // display it
      document.getElementById('starter').appendChild(tmp);
      }`;

  private signalRPrints: string[] = [];

  constructor(private httpClient: HttpClient, private snackbarService: SnackbarService) {}

  printConfirmationDocument(fileUri: string) {
    this.createPrintPage(fileUri);
  }

  loadAndPrint = (urlFunc: (docId: number) => string) => (documentId: string | number): void => {
    if (typeof documentId !== 'number') {
      documentId = parseInt(documentId, 10);
    }

    this.httpClient
      .post(urlFunc(documentId) + '?notificationName=Print', null, WillHandleErrorMessagingOption)
      .subscribe((res: DocumentDownload) => {
        if (res.fileUri) {
          this.createPrintPage(res.fileUri);
        } else {
          this.signalRPrints.push(documentId.toString());
        }
      }, this.handleError);
  };

  loadAndPrintCallback = (urlFunc: (docId: number) => string) => (
    documentId: string | number,
  ): void => {
    if (typeof documentId !== 'number') {
      documentId = parseInt(documentId, 10);
    }

    const index = this.signalRPrints.indexOf(documentId.toString());

    if (index >= 0) {
      this.signalRPrints.splice(index, 1);
      this.loadAndPrint(urlFunc)(documentId);
    }
  };

  // Using an arrow function to bind this context
  private createPrintPage = (docUrl: string) => {
    if (!docUrl) {
      throw new Error('Could not get Document for printing.');
    }

    this.httpClient
      .get(docUrl, {
        responseType: 'blob',
        observe: 'response',
        headers: WillHandleErrorMessagingHeader,
      })
      .subscribe((res: HttpResponse<Blob>) => {
        const blobUrl = URL.createObjectURL(res.body);
        switch (res.headers.get('content-type')) {
          case 'image/bmp':
          case 'image/gif':
          case 'image/jpeg':
          case 'image/png':
          case 'image/svg+xml': {
            let windowContent = '<!DOCTYPE html>';
            windowContent += '<html>';
            windowContent += '<head>';
            windowContent += `<script>${this.printJSPart1}${blobUrl}${this.printJSPart2}</script>`;
            windowContent += '</head>';
            windowContent += '<body><div id="starter"></div></body>';
            windowContent += '</html>';
            const printWin = window.open('', 'printpage');
            printWin.document.open();
            printWin.document.write(windowContent);
            printWin.document.close();
            printWin.focus();
            break;
          }
          case 'application/pdf': {
            const pdfWindow = window.open(blobUrl);
            pdfWindow.focus();
            break;
          }
          default:
            this.snackbarService.openSnackBarFailure(
              'This document cannot printed in the browser. Please download it instead.',
            );
        }
      }, this.handleError);
  };

  private handleError = (error: HttpErrorResponse) => {
    this.snackbarService.openSnackBarFailure('Document could not be printed at this time.');

    switch (error.status) {
      case 404:
        console.error(`Failure to find document. ${error.error}`);
        break;
      case 500:
        console.error(`Document could not be loaded for printing. ${error.error}`);
        break;
      default:
        console.error(
          `Document could not be loaded for printing due to an unexpected error. HTTP Status: ${error.status}, Message: ${error.error}`,
        );
    }
  };
}
